import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { WalletManager } from '../managers/wallet.manager';
import { Kcc20AdminApiService } from '../services/admin/kcc20-admin-api.service';

const MIGRATION_ADMIN_ROLES = ['SNAPSHOT_MIGRATOR', 'SYS_ADMIN'];

export const migrationAdminRouteGuard: CanActivateFn = async (): Promise<
  boolean | UrlTree
> => {
  const walletManager = inject(WalletManager);
  const router = inject(Router);
  const adminApi = inject(Kcc20AdminApiService);

  if (environment.useMockData) {
    return true;
  }

  await walletManager.awaitSessionRestore();
  if (!walletManager.signedWalletSignal()) {
    return router.parseUrl('/migrations');
  }

  try {
    const admin = await firstValueFrom(adminApi.getMe());
    return admin.roles.some((role) => MIGRATION_ADMIN_ROLES.includes(role))
      ? true
      : router.parseUrl('/migrations');
  } catch {
    return router.parseUrl('/migrations');
  }
};
